// extracted by mini-css-extract-plugin
module.exports = {"locationLabel":"PartnerDetails_locationLabel__ArAGT","languageLabel":"PartnerDetails_languageLabel__BSx4C"};